import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";

function ThankYou() {
  const navigate = useNavigate();
  const handleGoBack = () => {
    console.log("handle back");
    navigate(`/`);
  };

  return (
    <>
      <section className="thankyou">
        <div className="container">
          <div className="row">
            <div className="col-md-6 order-md-2">
              <div className="content">
                {/* <h4>Thank you.</h4> */}
                <h4>Your application is already with us.</h4>
                <p>
                  Thank you for showing interest in <br /> ICICI Bank’s Aspire
                  programme.
                </p>
                <p>Wishing you all the best.</p>
              </div>
            </div>
            <div className="col-md-6 order-md-1">
              <div className="successfulimg"></div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default ThankYou;
